import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $;
import { IMyDpOptions, IMyDate } from 'mydatepicker';
import { ViewChild, ElementRef, NgZone } from '@angular/core';
import { holidays } from '../../../../assets/holidays';
declare var google: any;
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import { _ } from 'underscore';
import { environment } from '../../../../environments/environment';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { CommercialService } from '../../questionnaire/commercial.service';
const filesize = require('filesize');
import { Router, Route } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-confirm-enrollment',
  templateUrl: './confirm-enrollment.component.html',
  styleUrls: ['./confirm-enrollment.component.css'],
})
export class ConfirmEnrollmentComponent implements OnInit {
  public model: any;
  quesResponse = {
    yourName: '',
    legalEntityName: '',
    emailAddress: '',
    yourTitlePosition: '',
    phoneNumber: '',
    bestTimeToContact: '',
    billingAddress: '',
    serviceType: '',
    requestedProductType: '',
    contractExpirationDate: '',
    requestedSwitchDate: '',
    requestedContractTerm: '',
    projectType: '',
    requestedStartDate: '',
    reqpermits: '',
  };
  esiidArrayValue = [];
  pointer_name;
  requestSwitchDateValue = [];
  requestedStartDateArray = [];
  geometryAddressArray = [];
  questionsArray = [];
  addAnotherAddress = [];
  sessionUserResponse;
  fieldResponse;
  errorMsg = false;
  invalidFileMsg = false;
  url = environment.api_url;
  contactSaveBtn = false;
  uploadedFilename = [];
  display = 'none';
  hasAnotherDropZoneOver = false;
  invalidFileSizeMsg = false;
  public uploader: FileUploader = new FileUploader({
    url: this.url + '/commercialfileupload',
    itemAlias: 'photo',
  });
  ShowMobileModel = false;
  showConfirmContactInfo = true;
  showMobileproductEdit = false;
  ShowConfirmProduct = false;
  confirmButton;
  confirmYesButton;
  confirmcheckbox = false;
  yesCheckBox = false;
  confirmWeb = false;
  mobileShowLocation = true;
  mbEditShowLocation = false;
  mbBusinessclick = false;
  businessMobile;
  hgHolidays: Array<any>;
  disableDays: Array<IMyDate> = [];
  public myDatePickerOptions1: IMyDpOptions;
  public myDatePickerOptions2: IMyDpOptions;
  public myDatePickerOptions3: IMyDpOptions;
  public switchModel: any;
  public startDateValue: any;
  public expirationModel: any;
  commercialResponses;

  // google auto complete
  // For ngx-google-autocomplete
  @ViewChild('places', { static: true }) places: GooglePlaceDirective;
  @ViewChild('search', { static: true }) public searchElement: ElementRef;
  @ViewChild('Suite', { static: true }) inputEl: ElementRef;
  @ViewChild('Suite_mob', { static: true }) inputEl_mob: ElementRef;
  @ViewChild('template', { static: true }) template: ElementRef;
  @ViewChild('noservice', { static: true }) noService: ElementRef;
  @Output() selectOn: EventEmitter<any> = new EventEmitter();
  isAddressSelected = false;
  geoMapAddress;
  deviceWidth;
  lat;
  lng;
  formatedAddress;
  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
  };
  address;
  // index = 0;
  showMap = false;
  index = 0;
  options = {
    types: [],
    componentRestrictions: { country: 'US' },
  };
  userResponses;
  addresses = [];
  switchDates = [];
  permissions = [];
  projects = [];
  expirations = [];
  services = [];
  callUtilityAPI = false;
  zipcode;
  utilities = [];
  selectedUtility;
  temporaryAddresses = [];
  modalRef: BsModalRef;
  showUtilities = false;
  addressIndex;
  addressId;
  tempserviceaddress = {
    requestedProductType: '',
    PermitsInspection: '',
    projectType: '',
    RequestedContractTerm: '',
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private commercialService: CommercialService,
    private modalService: BsModalService
  ) {
    this.hgHolidays = holidays.hgHolidays;
    for (let i = 0; i < this.hgHolidays.length; i++) {
      this.disableDays.push({
        year: this.hgHolidays[i].year,
        month: this.hgHolidays[i].month,
        day: this.hgHolidays[i].day,
      });
    }

    this.myDatePickerOptions1 = {
      // other options...
      todayBtnTxt: 'Today',
      dateFormat: 'mm/dd/yyyy',
      disableWeekends: true,
      disableDays: this.disableDays,
      firstDayOfWeek: 'su',
      inline: false,
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true,
    };

    this.myDatePickerOptions2 = {
      // other options...
      todayBtnTxt: 'Today',
      dateFormat: 'mm/dd/yyyy',
      firstDayOfWeek: 'su',
      inline: false,
      disableWeekends: true,
      disableDays: this.disableDays,
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true,
    };

    this.myDatePickerOptions3 = {
      // other options...
      todayBtnTxt: 'Today',
      dateFormat: 'mm/dd/yyyy',
      disableWeekends: true,
      disableDays: this.disableDays,
      firstDayOfWeek: 'su',
      showClearDateBtn: false,
      editableDateField: false,
      inline: false,
      openSelectorOnInputClick: true,
    };
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  ngOnInit() {
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { types: ['geocode'] }
    );

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.selectOn.emit(this.getFormattedAddress(autocomplete.getPlace(), ''));
      // });
    });

    this.commercialService.currentMessage.subscribe((message) => {
      if (!_.isEmpty(message)) {
        if (message['backFrom'] === 'preCongrats') {
          this.confirmWeb = true;
        }
      }
    });

    // Session storage values
    this.uploader.onBeforeUploadItem = (file) => {};
    this.uploader.onAfterAddingFile = (file) => {
      this.invalidFileMsg = false;
      this.invalidFileSizeMsg = false;
      file.withCredentials = false;
      // console.log.log('uploader onAfterAddingFile' + this.uploader.queue.length);
      let index;
      if (this.uploader.queue.length > 0) {
        index = this.uploader.queue.length - 1;
      } else {
        index = 0;
      }
      this.uploader.queue[index].file['fileIndex'] = this.addressId;
      for (let i = 0; i < this.uploader.queue.length; i++) {
        if (
          this.uploader.queue[i].file.type === 'image/png' ||
          this.uploader.queue[i].file.type === 'image/bmp' ||
          this.uploader.queue[i].file.type === 'image/svg+xml' ||
          this.uploader.queue[i].file.type === 'image/jpeg' ||
          this.uploader.queue[i].file.type === 'application/pdf'
        ) {
          if (this.uploader.queue[i].file.size < 10000000) {
            const actualFileSize = filesize(this.uploader.queue[i].file.size);
            this.uploader.queue[i].file['unitSize'] = actualFileSize;
          } else {
            this.invalidFileSizeMsg = true;
            this.uploader.queue.pop();
          }
        } else {
          this.invalidFileMsg = true;
          this.uploader.queue.pop();
        }
      }
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      this.uploadedFilename.push(response);
      this.commercialService.attachments.push(response);
    };
    if (!_.isEmpty(sessionStorage.getItem('commercialResponses'))) {
      this.commercialResponses = JSON.parse(
        sessionStorage.getItem('commercialResponses')
      );
      this.questionsArray.push(this.commercialResponses);
    }
    this.sessionData();
  }

  removeFile(removedfile) {
    removedfile.remove();
    if (this.uploader.queue.length < 5) {
      this.errorMsg = false;
    }
  }
  public fileOverAnother(e: any, i): void {
    this.hasAnotherDropZoneOver = e;
    if (e === true) {
      this.addressId = i;
    }
  }

  onTempImageSelected(event, i) {
    this.addressId = i;
  }

  sessionData() {
    const addressObj = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '004',
    });
    const servicesObj = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '009',
    });
    const spSwitch = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '0011',
    });
    const nsSwitch = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '0013',
    });
    const permissionsObj = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '0014',
    });
    const projectsOj = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '0012',
    });
    const expirationObj = _.findWhere(this.commercialResponses.userResponses, {
      com_question_id: '0010',
    });
    this.addresses = addressObj.fieldValue;
    this.temporaryAddresses = this.addresses;
    this.services = servicesObj.fieldValue;
    if (permissionsObj !== undefined) {
      this.permissions = permissionsObj.fieldValue;
    }
    if (projectsOj !== undefined) {
      this.projects = projectsOj.fieldValue;
    }
    if (expirationObj !== undefined) {
      this.expirations = expirationObj.fieldValue;
    }
    const services = servicesObj.fieldValue;
    this.switchDates = [];
    for (let i = 0; i < this.addresses.length; i++) {
      if (services[i].value === 'New Service') {
        this.switchDates.push(nsSwitch.fieldValue[i]);
      } else {
        this.switchDates.push(spSwitch.fieldValue[i]);
      }
    }
    const dates = [];
    _.each(this.switchDates, function (item) {
      dates.push(new Date(JSON.parse(item.value.date)));
    });
    this.switchDates = dates;
    _.each(this.expirations, function (item) {
      if (item !== null) {
        if (typeof item.value !== 'string') {
          const date = new Date(JSON.parse(item.value.date));
          let month;
          if (date.getMonth() + 1 < 10) {
            month = '0' + (date.getMonth() + 1);
          } else {
            month = date.getMonth() + 1;
          }
          item.value = month + '/' + date.getDate() + '/' + date.getFullYear();
        }
      }
    });
    this.fieldResponse = _.findWhere(this.questionsArray[0].userResponses, {
      com_question_id: '0022',
    });
    if (!_.isEmpty(this.fieldResponse)) {
      this.quesResponse.yourName =
        this.fieldResponse.fieldValue.firstName +
        ' ' +
        this.fieldResponse.fieldValue.lastName;
      this.quesResponse.phoneNumber = this.fieldResponse.fieldValue.phone;
      this.quesResponse.emailAddress = this.fieldResponse.fieldValue.email;
      this.quesResponse.yourTitlePosition = this.fieldResponse.fieldValue.title;
      this.quesResponse.billingAddress = this.fieldResponse.fieldValue
        .billingAddress
        ? this.fieldResponse.fieldValue.billingAddress
        : '';
    }
    const bestTimeToContact = _.findWhere(
      this.questionsArray[0].userResponses,
      { com_question_id: '0023' }
    );
    if (!_.isEmpty(bestTimeToContact)) {
      this.quesResponse.bestTimeToContact = bestTimeToContact.fieldValue;
    } else {
      this.quesResponse.bestTimeToContact = '';
    }
    const legalEntityName = _.findWhere(this.questionsArray[0].userResponses, {
      com_question_id: '0019',
    });
    if (!_.isEmpty(legalEntityName)) {
      this.quesResponse.legalEntityName = legalEntityName.fieldValue;
    } else {
      this.quesResponse.legalEntityName = '';
    }
    const requestedProductType = _.findWhere(
      this.questionsArray[0].userResponses,
      { com_question_id: '0016' }
    );
    if (!_.isEmpty(requestedProductType)) {
      this.quesResponse.requestedProductType = requestedProductType.fieldValue;
    } else {
      this.quesResponse.requestedProductType = '';
    }
    const requestedContractTerm = _.findWhere(
      this.questionsArray[0].userResponses,
      { com_question_id: '0017' }
    );
    if (!_.isEmpty(requestedContractTerm)) {
      this.quesResponse.requestedContractTerm =
        requestedContractTerm.fieldValue;
    } else {
      this.quesResponse.requestedContractTerm = '';
    }
    const billingAddress = _.findWhere(this.questionsArray[0].userResponses, {
      com_question_id: '0022',
    });

    const billadd = _.findWhere(this.questionsArray[0].userResponses, {
      com_question_id: '004',
    });
  }

  // Google auto complete
  public handleAddressChange(address, i) {
    this.addressIndex = i;
    this.isAddressSelected = true;
    this.geoMapAddress = address;
    if (typeof address.geometry.location.lng === 'number') {
      this.lng = address.geometry.location.lng;
      this.lat = address.geometry.location.lat;
    } else {
      this.lng = address.geometry.location.lng();
      this.lat = address.geometry.location.lat();
    }
    for (let kl = 0; kl < this.geometryAddressArray.length; kl++) {
      const existArrayDelete = this.geometryAddressArray[kl].index;
      if (existArrayDelete === i) {
        this.geometryAddressArray.splice(kl, 1);
      }
    }
    this.geometryAddressArray.push({
      index: i,
      geoMapAddress: this.geoMapAddress,
    });
    this.getFormattedAddress(address, i);
  }

  getFormattedAddress(place, i) {
    this.formatedAddress = place.formatted_address;
    this.pointer_name = place.name;
    let addressValue = '';
    for (let j = 0; j < place.address_components.length; j++) {
      const addressType = place.address_components[j].types[0];
      if (this.componentForm[addressType]) {
        const val =
          place.address_components[j][this.componentForm[addressType]];
        addressValue = addressValue + addressType + ':' + val + ';';
      }
      if (place.address_components[j].types[0] === 'postal_code') {
        this.zipcode = place.address_components[j].long_name;
      }
    }
    if (!this.callUtilityAPI) { 
      this.commercialService.getUtilies(this.zipcode,this.formatedAddress).subscribe((response) => {
        if (
          response['statusCode'] === '001' &&
          response['statusText'] === 'success' &&
          response['data'].length > 0
        ) {
          if (response['data'].length > 1) {
            this.utilities = response['data'];
            this.showUtilities = true;
          } else {
            this.selectedUtility = response['data'][0].Utility;
            this.temporaryAddresses[i].utility = this.selectedUtility;
            this.isAddressSelected = true;
            this.showUtilities = false;
          }
        } else {
          this.utilities = [];
          this.temporaryAddresses[i].utility = 'Not Serviceable';
          this.isAddressSelected = false;
        }
      });
    } else {
      this.isAddressSelected = true;
    }
    this.address = addressValue;
    this.showMap = true;
    if (i !== '') {
      const index = _.indexOf(_.pluck(this.geometryAddressArray, 'index'), i);
      this.temporaryAddresses[i].formatedAddress = this.formatedAddress;
      this.temporaryAddresses[i].pointer_name = this.pointer_name;
      this.geometryAddressArray[index]['formatedAddress'] =
        this.formatedAddress;
      this.geometryAddressArray[index]['pointer_name'] = this.pointer_name;
      this.geometryAddressArray[index]['address'] = this.address;
      this.geometryAddressArray[index]['utility'] = this.selectedUtility;
    }
  }

  selectUtility(utility) {
    this.selectedUtility = utility;
    this.temporaryAddresses[this.addressIndex].utility = this.selectedUtility;
    this.isAddressSelected = true;
  }

  openModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  markerIconUrl() {
    return require('../../../../assets/images/map-marker-2.png');
  }

  // To set the validation flag on editting the i/p
  setFlag() {
    this.isAddressSelected = false;
    this.callUtilityAPI = false;
  }

  getDate() {}
  submitFiles() {
    // Code to upload files
    if (this.uploader.queue.length > 0) {
      this.uploader.uploadAll();
    }

    const userResponses = {
      com_user_responce: this.commercialService.userResponse.userResponses,
      attachments: this.commercialService.attachments,
      addAddress: this.commercialService.addAddress,
    };
    const enrollbody = new HttpParams()
      .append('userResponses', JSON.stringify(userResponses))
      .append('enrollContactObj', JSON.stringify(this.quesResponse));
    localStorage.setItem('enrollContactObj', JSON.stringify(this.quesResponse));
    this.http
      .post(this.url + '/commercial/enrollment', enrollbody)
      .subscribe((notifyres: any) => {
        const result = notifyres;
        if (result && result.statusCode === '002') {
        } else {
          this.router.navigate(['commercial', 'pre-congrats']);
        }
      });
  }

  editContactInfo() {
    $('#contactModal').modal('show');
  }

  editProduct(i) {
    this.index = i;
    if (this.services[this.index].value === 'New Service') {
      this.startDateValue = {
        date: {
          year: this.switchDates[this.index].getFullYear(),
          month: this.switchDates[this.index].getMonth() + 1,
          day: this.switchDates[this.index].getDate(),
        },
      };
    } else {
      this.switchModel = {
        date: {
          year: this.switchDates[this.index].getFullYear(),
          month: this.switchDates[this.index].getMonth() + 1,
          day: this.switchDates[this.index].getDate(),
        },
      };
      if (this.expirations[this.index].value !== 'No, already expired') {
        this.model = {
          date: {
            year: new Date(this.expirations[this.index].value).getFullYear(),
            month: new Date(this.expirations[this.index].value).getMonth() + 1,
            day: new Date(this.expirations[this.index].value).getDate(),
          },
        };
      }
    }
    $('#productModal').modal('show');
  }

  textChanged(ev) {
    this.tempserviceaddress.requestedProductType =
      this.quesResponse.requestedProductType;
    if (ev) {
      this.quesResponse.requestedProductType = ev;
    }
  }

  ProjectTypeChanged(ev, i) {
    if (this.tempserviceaddress.projectType === '') {
      this.tempserviceaddress.projectType = this.projects[i].value;
    }
    if (ev) {
      this.projects[i].value = ev;
    }
  }

  permitsInspectionChanged(ev, i) {
    if (this.tempserviceaddress.PermitsInspection === '') {
      this.tempserviceaddress.PermitsInspection = this.permissions[i].value;
    }
    if (ev) {
      this.permissions[i].value = ev;
    }
  }

  RequestedContractTermChanged(ev) {
    this.tempserviceaddress.RequestedContractTerm =
      this.quesResponse.requestedContractTerm;
    if (ev) {
      this.quesResponse.requestedContractTerm = ev;
    }
  }

  // Product model close
  modelProductClose() {
    $('#productModal').modal('hide');
    this.sessionData();
    if (this.tempserviceaddress.requestedProductType) {
      this.quesResponse.requestedProductType =
        this.tempserviceaddress.requestedProductType;
    }

    if (this.tempserviceaddress.projectType) {
      this.projects[this.index].value = this.tempserviceaddress.projectType;
    }

    if (this.tempserviceaddress.PermitsInspection) {
      this.permissions[this.index].value =
        this.tempserviceaddress.PermitsInspection;
    }

    if (this.tempserviceaddress.RequestedContractTerm) {
      this.quesResponse.requestedContractTerm =
        this.tempserviceaddress.RequestedContractTerm;
    }

    this.tempserviceaddress.requestedProductType = '';
    this.tempserviceaddress.projectType = '';
    this.tempserviceaddress.PermitsInspection = '';
    this.tempserviceaddress.RequestedContractTerm = '';
  }

  // Contact info model close
  modelContactClose() {
    this.sessionData();
    $('#contactModal').modal('hide');
  }

  // Back button in contact confirm page
  contactBack() {
    this.router.navigate(['commercial', 'questionnaire']);
  }

  createAccount(event, myForm, formValid, viewProcess) {
    if (myForm.valid !== false) {
      for (let i = 0; i < this.questionsArray[0].userResponses.length; i++) {
        if (
          this.questionsArray[0].userResponses[i].com_question_id === '0019' &&
          this.questionsArray[0].userResponses[i].com_question_id
        ) {
          this.questionsArray[0].userResponses[i].fieldValue =
            myForm.form.value.LegalEntityName;
        }
        if (
          this.questionsArray[0].userResponses[i].com_question_id === '0023'
        ) {
          this.questionsArray[0].userResponses[i].fieldValue =
            myForm.form.value.BestTimeToContact;
        }
        if (
          this.questionsArray[0].userResponses[i].com_question_id === '0022'
        ) {
          // this.questionsArray[0].userResponses[i].fieldValue.firstName = myForm.form.value.YourName;
          this.questionsArray[0].userResponses[i].fieldValue.phone =
            myForm.form.value.PhoneNumber;
          this.questionsArray[0].userResponses[i].fieldValue.email =
            myForm.form.value.email;
          this.questionsArray[0].userResponses[i].fieldValue.confirmEmail =
            myForm.form.value.email;
          this.questionsArray[0].userResponses[i].fieldValue.title =
            myForm.form.value.YourTitlePosition;

          this.questionsArray[0].userResponses[i].fieldValue.firstName =
            myForm.form.value.YourName;
          this.questionsArray[0].userResponses[i].fieldValue.lastName = '';
        }

        if (this.questionsArray[0].userResponses[i].com_question_id === '004') {
          this.questionsArray[0].userResponses[
            i
          ].fieldValue[0].formatedAddress = myForm.form.value.BillingAddress;
        }
        sessionStorage.setItem(
          'commercialResponses',
          JSON.stringify(this.questionsArray[0])
        );
        $('#contactModal').modal('hide');
        this.sessionData();
        if (viewProcess === 'mobileContact') {
          this.ShowMobileModel = false;
          this.showConfirmContactInfo = true;
        }
      }
    }
  }

  createProductPreference(event, myForm1, formValid, view) {
    for (let i = 0; i < this.questionsArray[0].userResponses.length; i++) {
      const productTypeData = _.findWhere(
        this.questionsArray[0].userResponses,
        { com_question_id: '0016' }
      );
      if (
        this.questionsArray[0].userResponses[i].com_question_id &&
        this.questionsArray[0].userResponses[i].com_question_id === '0016' &&
        productTypeData
      ) {
        if (myForm1.form.value.RequestedProductType === undefined) {
          myForm1.form.value.RequestedProductType = 'Fixed rate';
        }
        this.questionsArray[0].userResponses[i].fieldValue =
          myForm1.form.value.RequestedProductType;
      }
      const RequestedContractData = _.findWhere(
        this.questionsArray[0].userResponses,
        { com_question_id: '0017' }
      );
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0017' &&
        myForm1.form.value !== null &&
        RequestedContractData
      ) {
        this.questionsArray[0].userResponses[i].fieldValue =
          myForm1.form.value.RequestedContractTerm;
      }
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0011' &&
        myForm1.form.value.mydate2
      ) {
        if (myForm1.form.value.mydate2.jsdate) {
          const formatDateSwitch = myForm1.form.value.mydate2.jsdate;
          this.questionsArray[0].userResponses[i].fieldValue[
            this.index
          ].value.date = JSON.stringify(new Date(formatDateSwitch));
        }
      }
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0013' &&
        myForm1.form.value.mydate3
      ) {
        if (myForm1.form.value.mydate3.jsdate) {
          const formatDateStart = myForm1.form.value.mydate3.jsdate;
          this.questionsArray[0].userResponses[i].fieldValue[
            this.index
          ].value.date = JSON.stringify(new Date(formatDateStart));
        }
      }

      const mydate1Data = _.findWhere(this.questionsArray[0].userResponses, {
        com_question_id: '0010',
      });
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0010' &&
        myForm1.form.value.mydate1 &&
        mydate1Data
      ) {
        if (myForm1.form.value.mydate1.jsdate) {
          const formatDate = myForm1.form.value.mydate1.jsdate;
          this.questionsArray[0].userResponses[i].fieldValue[this.index].value =
            {
              value: 'in_contract',
              date: JSON.stringify(new Date(formatDate)),
            };
          this.questionsArray[0].userResponses[i].fieldValue[
            this.index
          ].value.date = JSON.stringify(new Date(formatDate));
        }
      }
      const PermitsInspectionData = _.findWhere(
        this.questionsArray[0].userResponses,
        { com_question_id: '0014' }
      );
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0014' &&
        myForm1.form.value !== null &&
        myForm1.form.value.PermitsInspection &&
        PermitsInspectionData
      ) {
        this.questionsArray[0].userResponses[i].fieldValue[this.index].value =
          myForm1.form.value.PermitsInspection;
      }
      const ProjectTypeData = _.findWhere(
        this.questionsArray[0].userResponses,
        { com_question_id: '0012' }
      );
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0012' &&
        myForm1.form.value !== null &&
        myForm1.form.value.ProjectType &&
        ProjectTypeData
      ) {
        this.questionsArray[0].userResponses[i].fieldValue[this.index].value =
          myForm1.form.value.ProjectType;
      }
      const requestedStartDateValue = _.findWhere(
        this.questionsArray[0].userResponses,
        { com_question_id: '0013' }
      );
      if (
        this.questionsArray[0].userResponses[i].com_question_id === '0013' &&
        myForm1.form.value !== null &&
        myForm1.form.value.myDate3 &&
        requestedStartDateValue
      ) {
        if (myForm1.form.value.mydate3.jsdate) {
          const formatDate = myForm1.form.value.mydate3.jsdate;
          this.questionsArray[0].userResponses[i].fieldValue[
            this.index
          ].value.date = JSON.stringify(new Date(formatDate));
        }
      }

      sessionStorage.setItem(
        'commercialResponses',
        JSON.stringify(this.questionsArray[0])
      );
      $('#productModal').modal('hide');
      this.sessionData();
      if (view === 'mobileProd') {
        this.showMobileproductEdit = false;
        this.ShowConfirmProduct = true;
      }
    }
  }

  // Edit Business Location
  businessEdit(view) {
    this.showUtilities = false;
    this.addresses = this.temporaryAddresses;
    setTimeout(() => {
      // let index = 0;
      for (let m = 0; m < this.questionsArray[0].userResponses.length; m++) {
        if (
          this.questionsArray[0].userResponses[m].com_question_id === '004' &&
          this.questionsArray[0].userResponses[m]
        ) {
          // console.log.log(this.geometryAddressArray);
          for (let ab = 0; ab <= this.geometryAddressArray.length; ab++) {
            if (
              this.geometryAddressArray.length > 0 &&
              this.geometryAddressArray[ab]
            ) {
              const index = this.geometryAddressArray[ab].index;
              this.questionsArray[0].userResponses[m].fieldValue[
                index
              ].formatedAddress = this.geometryAddressArray[ab].formatedAddress;
              this.questionsArray[0].userResponses[m].fieldValue[
                index
              ].geoMapAddress = this.geometryAddressArray[ab].geoMapAddress;
              this.questionsArray[0].userResponses[m].fieldValue[
                index
              ].address = this.geometryAddressArray[ab].address;
              this.questionsArray[0].userResponses[m].fieldValue[
                index
              ].pointer_name = this.geometryAddressArray[ab].pointer_name;
            }
            if (this.esiidArrayValue.length > 0) {
              for (let y = 0; y < this.esiidArrayValue.length; y++) {
                this.esiidArrayValue[y].esiids = _.filter(
                  this.esiidArrayValue[y].esiids,
                  function (item) {
                    return item.value !== '';
                  }
                );
                this.questionsArray[0].userResponses[m].fieldValue[y].esiids =
                  this.esiidArrayValue[y].esiids;
              }
            }
            sessionStorage.setItem(
              'commercialResponses',
              JSON.stringify(this.questionsArray[0])
            );
          }
        } else {
          // console.log.log('*******');
        }
      }
      this.sessionData();
      $('#businessLocation').modal('hide');
      if (view === 'mbBusiness') {
        this.mobileShowLocation = true;
        this.mbEditShowLocation = false;
      }
    }, 500);
  }

  // Close the Location model
  modellocationClose() {
    $('#businessLocation').modal('hide');
  }

  // Show the mobile edit model
  editContactMobileInfo() {
    this.ShowMobileModel = true;
    this.showConfirmContactInfo = false;
  }

  // Mobile edit model close
  mobileContactClose() {
    this.sessionData();
    this.ShowMobileModel = false;
    this.showConfirmContactInfo = true;
  }

  // Mobile Edit product Model close
  mobileProductClose() {
    this.sessionData();
    this.showMobileproductEdit = false;
    this.ShowConfirmProduct = true;
  }

  // Show the edit product preference in mobile
  editProductMobile(i) {
    this.index = i;
    if (this.services[this.index].value === 'New Service') {
      this.startDateValue = {
        date: {
          year: this.switchDates[this.index].getFullYear(),
          month: this.switchDates[this.index].getMonth() + 1,
          day: this.switchDates[this.index].getDate(),
        },
      };
    } else {
      this.switchModel = {
        date: {
          year: this.switchDates[this.index].getFullYear(),
          month: this.switchDates[this.index].getMonth() + 1,
          day: this.switchDates[this.index].getDate(),
        },
      };
      if (this.expirations[this.index].value !== 'No, already expired') {
        this.model = {
          date: {
            year: new Date(this.expirations[this.index].value).getFullYear(),
            month: new Date(this.expirations[this.index].value).getMonth() + 1,
            day: new Date(this.expirations[this.index].value).getDate(),
          },
        };
      }
    }
    this.ShowConfirmProduct = false;
    this.showMobileproductEdit = true;
  }

  // Click confirm button in mobile view
  confirmBtn(type) {
    if (type === 'web') {
      this.confirmButton = document.getElementById('confirm1');
      if (this.confirmButton.checked === true) {
        this.confirmcheckbox = true;
        if (this.yesCheckBox) {
          this.yesCheckBox = false;
        }
      } else {
        this.confirmcheckbox = false;
      }
    } else if (type === 'mobile') {
      this.businessMobileClick();
      this.router.navigate(['commercial', 'pre-congrats']);
    }
  }

  // Click Yes button in mobile view - product Preference
  confirmYesBtn() {
    this.confirmYesButton = document.getElementById('confirm2');
    if (this.confirmYesButton.checked === true) {
      this.yesCheckBox = true;
    } else {
      this.yesCheckBox = false;
    }
  }

  // Webview hide the Contact info and show Business location.
  contactConfirmPro() {
    this.confirmWeb = true;
  }

  // Business location component ts file content
  editLocation() {
    // to show modal
    this.temporaryAddresses = this.addresses;
    this.isAddressSelected = true;
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { types: ['geocode'] }
    );
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.selectOn.emit(this.getFormattedAddress(autocomplete.getPlace(), ''));
    });
    $('#businessLocation').modal('show');
  }

  // Back button in Business location
  businessBack() {
    this.confirmWeb = false;
  }

  // show the location edit model
  editLocationMobile() {
    this.mobileShowLocation = false;
    this.mbEditShowLocation = true;
  }
  // Hide the edit business model - Mobile View
  mobileBusinessClose() {
    window.location.reload();
    this.mobileShowLocation = true;
    this.mbEditShowLocation = false;
  }

  // Mobile view business model click -- Added SubmitFiles to save data for Commercial
  businessMobileClick() {
    this.businessMobile = document.getElementById('confirm3');
    if (this.businessMobile.checked === true) {
      this.mbBusinessclick = true;
      this.submitFiles();
    }
  }

  // Save the modified changes in contact info
  contactSave() {}

  // Remove the Essid id
  essidClose(addAnother, index) {
    for (let k = 0; k <= this.addAnotherAddress.length; k++) {
      const idForEssid = <HTMLInputElement>(
        document.getElementById('esiidVal' + k)
      );
      for (let m = 0; m < this.questionsArray[0].userResponses.length; m++) {
        if (
          this.questionsArray[0].userResponses[m] &&
          this.questionsArray[0].userResponses[m].com_question_id === '004'
        ) {
          if (this.questionsArray[0].userResponses[m].fieldValue[addAnother]) {
            // this.addAnotherAddress[k].esiids.splice(index, 1);
            this.questionsArray[0].userResponses[m].fieldValue[
              addAnother
            ].esiids.splice(index, 1);
          }
          this.esiidArrayValue =
            this.questionsArray[0].userResponses[m].fieldValue;
        }
      }
      break;
    }
  }

  // Add esiid
  addEsiid(addAnother) {
    let addAnotherEsiid = 1;
    for (let k = 0; k <= this.addAnotherAddress.length; k++) {
      for (let m = 0; m < this.questionsArray[0].userResponses.length; m++) {
        if (
          this.questionsArray[0].userResponses[m] &&
          this.questionsArray[0].userResponses[m].com_question_id === '004'
        ) {
          if (
            this.questionsArray[0].userResponses[m].fieldValue[addAnother] &&
            addAnotherEsiid === 1
          ) {
            this.questionsArray[0].userResponses[m].fieldValue[
              addAnother
            ].esiids.push({ value: '' });
            addAnotherEsiid = 2;
          }
          this.esiidArrayValue =
            this.questionsArray[0].userResponses[m].fieldValue;
        }
      }
    }
  }

  getDateFormat(date) {
    date = JSON.parse(date);
    const today = new Date(date);
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = 0 + dd;
    }
    if (mm < 10) {
      mm = 0 + mm;
    }
    const returnDate = dd + '/' + mm + '/' + yyyy;
    return returnDate;
  }

  // Legal Button Blur function
  legalClick() {
    const saveLegalname = <HTMLInputElement>document.getElementById('yourName');
    const saveLegal = <HTMLInputElement>(
      document.getElementById('legalEntityName')
    );
    const saveEmail = <HTMLInputElement>document.getElementById('contactEmail');
    const saveTitle = <HTMLInputElement>(
      document.getElementById('yourTitlePosition')
    );
    const savePhone = <HTMLInputElement>document.getElementById('phone');
    const saveBilling = <HTMLInputElement>(
      document.getElementById('billingAddress')
    );
    if (
      saveLegalname.value !== '' &&
      saveLegal.value !== '' &&
      saveEmail.value !== '' &&
      saveTitle.value !== '' &&
      this.quesResponse.phoneNumber !== '' &&
      saveBilling.value !== '' &&
      this.quesResponse.phoneNumber.length === 12
    ) {
      this.contactSaveBtn = false;
    } else {
      this.contactSaveBtn = true;
    }
  }

  // contact mobile confirm
  mbContactConfirm() {}
}
